import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPolygonGeometry,
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface Boundary extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;

    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export const boundarySchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),

    geometry: polygonGeometrySchema,
    pole: pointGeometrySchema,
});

export const mockBoundary = ({
    id = 'b658bc7b-e258-4fcb-91e4-37e578355edd',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Boundary Name',

    geometry = mockPolygonGeometry(),
    pole = mockPointGeometry(),
}: Partial<Boundary> = {}): Boundary => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,

    geometry,
    pole,
});
